/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import countries from '../../services/phone.json'
import {
  bus
} from '../../main';
export default {
  name: 'author-user-details',
  components: {},
  props: [],
  data() {
    return {
      showTab: 'personal',
      userData: {},
      countryList: [],
      removeAuthorCourseId:'',
      authorID:''
    }
  },
  computed: {
    ...mapGetters([
      'getAuthorDetailsByIDGetter',

    ]),
    getUserList() {
      return this.userData = this.$store.getters.getAuthorDetailsByIDGetter.data
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserList,
    this.authorID = this.$route.params.authorId
  },
  methods: {
    cvFileDownFun: function () {   
    window.open(this.userData.user_details.profile.cv, "_blank");    
    },
    getCountryCode(mobile) {
      let countryCode = mobile.split(' ')[0];
      countryCode = countryCode.replace('+', '');
      let country = this.countryList.filter(item => (item.name) == (countryCode));
      if (country && country.length > 0) {
        country = country[0]
        country = `https://www.countryflags.io/${country.value}/shiny/32.png`
      } else {
        country = ''
      }
      return country;
    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    getUserListAgain() {
      this.$store.dispatch('getAuthorDetailsByIDFun', {
        id: this.$route.params.authorId
        })
    },
    removAuthorAssignedCourseModal(id) {
      $('#removAuthorAssignedCourseModal').modal();
      this.removeAuthorCourseId = id
    },
    removAuthorAssignedCourseConfirmationagain(){
      this.$store.dispatch('removeAssignedCourseAuthorFun', {
        data :{
          CourseId:this.removeAuthorCourseId,
          AuthorId:this.$route.params.authorId
        }
      }).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getAuthorDetailsByIDGetter
    }
  }
}